import IParamsDto from '@/models/dto/params.dto'
import devicesModule from '@/store/modules/devices.module'
import { deepCopy } from 'deep-copy-ts'
import RestClient from '../rest.client'
import DeviceUtil from '@/utils/device.util'

export default class DeviceService {
    static async getDevices() {
        return await RestClient.call({
            url: '/devices/',
            method: 'get',
        })
    }

    static async setDevice(deviceId: number, params: IParamsDto, speedLimit: number) {
        const refDevice = await devicesModule.getDevicebyId(deviceId)
        const device = deepCopy(refDevice)
        delete device?.position
        delete device?.positions
        device!.attributes!.speedLimit = DeviceUtil.formatKmhToKn(speedLimit).toString()
        device!.attributes!.params = params
        console.log(device)
        try {
            const response = await RestClient.call({
                url: `/devices/${deviceId}`,
                method: 'put',
                data: device,
            })
            refDevice!.attributes!.speedLimit = response.data.attributes!.speedLimit
            refDevice!.attributes!.params = response.data.attributes!.params

            return response
        } catch (error) {
            console.log(error)
            throw Error('Error al actualizar Dispositivo')
        }
    }
    static async updateTxState(deviceId: number, newDisabled: boolean) {
        const refDevice = await devicesModule.getDevicebyId(deviceId)
        const device = deepCopy(refDevice)
        delete device?.position
        delete device?.positions
        device!.disabled = newDisabled
        console.log(device)
        try {
            const response = await RestClient.call({
                url: `/devices/${deviceId}`,
                method: 'put',
                data: device,
            })
            refDevice!.disabled = response.data.disabled

            return response
        } catch (error) {
            console.log(error)
            throw Error('Error al actualizar Dispositivo')
        }
    }
}
